<template>
    <div class="calc">
        <div class="calc-row">
            <div class="calc-display">
                <p>{{ score }}</p>
            </div>
        </div>
        <div class="calc-row">
            <div class="number topleft" @click="calc('1')"><p>1</p></div>
            <div class="number" @click="calc('2')"><p>2</p></div>
            <div class="number topright" @click="calc('3')"><p>3</p></div>
        </div>
        <div class="calc-row">
            <div class="number" @click="calc('4')"><p>4</p></div>
            <div class="number" @click="calc('5')"><p>5</p></div>
            <div class="number" @click="calc('6')"><p>6</p></div>
        </div>
        <div class="calc-row">
            <div class="number" @click="calc('7')"><p>7</p></div>
            <div class="number" @click="calc('8')"><p>8</p></div>
            <div class="number" @click="calc('9')"><p>9</p></div>
        </div>
        <div class="calc-row">
            <div class="number bottomleft" @click="calc('backspace')"><p>&larr;</p></div>
            <div class="number" @click="calc('0')"><p>0</p></div>
            <div class="number bottomright" @click="calc('enter')"><p>&#10003;</p></div>
        </div>
    </div>
</template>

<script>


export default {

    name: 'Calc',

    data() {
        return {
            score: '0'
        }
        
    },

    methods: {
        calc(n) {

            // A number button was pressed
            if (n > -1 && n < 10) {
                if (this.score == 0) {
                    this.score = n;
                } else if (this.score.length < 3) {
                    this.score = this.score + n;
                }

            // The backspace button was pressed
            } else if (n == "backspace") {
                if (this.score > 0 && this.score.length > 1) {
                    this.score = this.score.substr(0, this.score.length - 1);
                } else {
                    this.score = "0";
                }

            // The enter button was pressed
            } else if (n == "enter") {
                if (this.score >= 0 && this.score <= 180) {
                    let finalScore = this.score;
                    this.$emit("submitScore", this.score);
                    this.score = 0;
                }
            }


            
        }
    }
}
</script>


<style scoped>

    .calc {
        position: absolute;
        bottom: 0px;
        right: 0px;
        margin: 0 5px 5px 0;
    }

    .calc-row {
        display: flex;
    }

    .calc-display {
        text-align: center;
        width: 250px;
        height: 60px;
        border: 1px solid #aaa;
        margin-right: 5px;
        margin-bottom: 5px;
        font-size: 60px;
        line-height: 60px;
        
        border-radius: 2px;
        display: flex;
        

        
    }
    .calc-display p {
        margin: auto;
        margin-top: -3px;
    }

    .number {
        text-align: center;
        width: 80px;
        height: 80px;
        /*border: 1px solid #aaa;*/
        margin-right: 5px;
        margin-bottom: 5px;
        font-size: 2.8em;
        border-radius: 5px;
        padding: 5px;
        box-sizing: border-box;
        box-shadow: 0 1px 3px rgba(0,0,0,0.48), 0 1px 2px rgba(0,0,0,0.60);
        display: flex;
    }

    .number p {
        margin: auto;
    }

    .number:hover {
        cursor: pointer;
        user-select: none;
    }

</style>
